<template>
  <transition name="el-loading-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="el-loading-mask rect-loading loading-mask"
      :style="{ backgroundColor: background || '' }"
      :class="[customClass, { 'is-fullscreen': fullscreen }]">
      <div class="el-loading-spinner">
        <div v-if="!spinner" class="loading-spinner">
          <div class="spinner">
            <div class="rect1" :style="{ background: rectBackground }"></div>
            <div class="rect2" :style="{ background: rectBackground }"></div>
            <div class="rect3" :style="{ background: rectBackground }"></div>
            <div class="rect4" :style="{ background: rectBackground }"></div>
            <div class="rect5" :style="{ background: rectBackground }"></div>
          </div>
        </div>
        <i v-else :class="spinner"></i>
        <p v-if="text" class="el-loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      customClass: '',
      rectBackground: null
    }
  },

  methods: {
    handleAfterLeave () {
      this.$emit('after-leave')
    },
    setText (text) {
      this.text = text
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.rect-loading {
  position: absolute;

  .loading-spinner {
    display: inline-block;
  }
}
</style>
